import { BaseModel } from '@Core';
import { Camera } from './Camera';

export interface CameraSIM extends BaseModel {
    CameraId: number;
    Camera?: Camera;
    NetworkProvider: string;
    SerialNumber: string;
    PhoneNumber: string;
    Status: SimStatus;
    Type: SimType;
}

export enum SimExistType {
    Camera = 'Camera',
    Phone = 'Phone',
    Serial = 'Serial',
}

export interface CameraSIMPreview extends CameraSIM {
    IsExist?: SimExistType[];
}

export enum SimType {
    O2,
    GoTo,
    Others,
}

export enum SimStatus {
    Active,
    Inactive,
    InStock,
    Lost,
}
